import { render, staticRenderFns } from "./PortfolioYearEndTransitionResultsStep.vue?vue&type=template&id=5b103af6&scoped=true"
import script from "./PortfolioYearEndTransitionResultsStep.vue?vue&type=script&lang=js"
export * from "./PortfolioYearEndTransitionResultsStep.vue?vue&type=script&lang=js"
import style0 from "./PortfolioYearEndTransitionResultsStep.vue?vue&type=style&index=0&id=5b103af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b103af6",
  null
  
)

export default component.exports